import { styled } from "@mui/material";
import { exProps } from "utils/mui";

export const CollapseWrapper = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column"
}))

export const CollapseButton = styled('button', exProps('open'))<{ open?: boolean }>(({ theme, open }) => ({
  cursor: "pointer",
  fontFamily: theme.typography.fontFamily,
  height: 34,
  fontWeight: 600,
  backgroundColor: theme.palette.background.paper,
  border: "none",
  color: "white",
  textAlign: "left",
  paddingLeft: theme.spacing(1.2),
  fontSize: 11,
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(0.5),
  display: "flex",
  alignItems: "center",

  ".arrow": {
    marginRight: theme.spacing(1),
    transition: theme.transitions.create('transform', { duration: 200 }),
    transform: open? `rotate(90deg)`: `rotate(0deg)`,
    width: theme.spacing(1.8)
  }
}))